import { Except } from 'type-fest'

import { Model, uuid } from '@/types/general'
import { MinimalCompany } from '@/types/company'
import { MinimalUser } from '@/types/user'

export interface MinimalLoadingList extends Model {
    id: uuid
    companyId: uuid
    provider: MinimalCompany
    providerNumber: string
    providerAccountNumber: string | null
    tripNumber: string
    remark: string | null
    originPort: Port
    destinationPorts: Port[]
    truckNumber: string | null
    trailerNumber: string | null
    flightNumber: string | null
    country: string
    userId: uuid | null
    user: MinimalUser | null
    departedAt: string
    loadedAt: string
    itemsCount: number
    routesCount: number
    createdAt: string | null
    updatedAt: string | null
}

export interface LoadingList extends Except<MinimalLoadingList, 'itemsCount' | 'routesCount'> {
    routes: LoadingListRoute[]
}

export interface MinimalLoadingListRoute extends Model {
    id: string
    route: string
    remark: string
    carrier: MinimalCompany
    carrierNumber: string
    carrierAccountNumber: string | null
    destinationPort: Port
    order: number
    departedAt: string | null
    itemsCount: number
    loadingList: { id: uuid; tripNumber: number } | null
}

export interface LoadingListRoute extends Except<
    MinimalLoadingListRoute,
    'itemsCount' | 'loadingList'
> {
    items: LoadingListRouteItem[]
}

export interface LoadingListRouteItem extends Model {
    id: uuid
    loadingListRouteId: uuid
    name: string
    loadingInstruction: string | null
    awbNumber: string
    amount: number
    weight: number
    volume: number
    description: string | null
    spls: string[] | null
}

export interface DefaultRemark extends Model {
    id: uuid
    companyId: uuid
    provider: MinimalCompany
    providerNumber: string
    providerAccountNumber: string | null
    carrier: MinimalCompany | null
    carrierAccountNumber: string | null
    weekday: number
    type: DefaultRemarksType | null
    departureTime: number
    loadingTime: number
    remark: string | null
}

export enum DefaultRemarksType {
    Truck = 0,
    Plane = 1,
}

export interface Port extends Model {
    id: string
    name: string
    shortName: string
}

export interface RoutesFormRoute extends Except<LoadingListRoute, 'destinationPort'> {
    carrierCompanyId: uuid | null
    destinationPortId: uuid
}

export interface RoutesForm {
    routes: RoutesFormRoute[]
}

export type RouteDraft = Record<uuid, RoutesForm & { timestamp: string | null }>
